import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { orderBy, startCase } from 'lodash';

import Select from '@joinforma/ui/components/Select';
import Option from '@joinforma/ui/components/Option';

import { EVENTS } from 'constants/events';
import { logRudderstackEvent } from 'utils/rudderstack';
import { StoreRoutes } from 'utils/routeGenerator';

interface Category {
  alias?: string;
  id: string;
  name: string;
  subcategories: Array<{
    eligible: boolean;
    value: string;
  }>;
}

interface Wallet {
  company_wallet_configuration: {
    is_twic_store_enabled?: boolean;
    wallet_name: string;
  };
  id: string;
}

const CategoryDropdown = styled(Select)`
  width: 100%;
`;

const CategorySelect = ({
  categories,
  filteredWallet,
  label = 'Browse By Category',
}: {
  categories: Array<Category>;
  filteredWallet: Wallet;
  label?: string;
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const orderedCategories = orderBy(
    categories,
    [(c) => (c.alias ? c.alias.toLowerCase() : c.name.toLowerCase())],
    'asc'
  );

  const handleCategoryChange = (value: string) => {
    const { id: categoryId, alias } = JSON.parse(value);
    logRudderstackEvent(EVENTS.StoreLandingDropdownClicked, {
      'Current Page': location.pathname,
      'Dropdown Type': 'Category Filter',
      'Selection Name': alias ?? categoryId,
    });

    const route = StoreRoutes.categoryLanding({
      alias,
      categoryId,
      walletId: filteredWallet.id,
    });
    navigate(route, {
      state: { ...location.state, origin: 'dropdown_selection' },
    });
  };

  return (
    <CategoryDropdown
      label={label}
      name="category-filter"
      onChange={handleCategoryChange}
    >
      {orderedCategories.map(({ alias, id, name }, index) => (
        <Option
          key={`${id} ${index}`}
          value={JSON.stringify({
            employee_wallet_id: filteredWallet.id,
            id,
            alias: alias ?? id,
          })}
        >
          {alias ? startCase(alias) : startCase(name)}
        </Option>
      ))}
    </CategoryDropdown>
  );
};

export default CategorySelect;
